module.exports = __webpack_public_path__ + "4bea6e28a6282c405bc867343de19b87.svg";